export function getMostSoldTypeContentPath(type) {
  return `research/infographics/most-sold-type/${type}`;
}

export function getMostSoldTypeTableContentPath(type) {
  return `widgets/most-sold-type/table/${type}`;
}

export function getTypeTitleCase(typeUrlParam) {
  const lowerCaseFirstLetterRegex = /\b[a-z]/g;
  return typeUrlParam
    .replaceAll('suv', 'SUV')
    .replaceAll('-', ' ')
    .replaceAll('3 row', '3-Row')
    .replaceAll(lowerCaseFirstLetterRegex, match => match.toUpperCase());
}
